import { UseMutationOptions, useMutation } from "@tanstack/react-query";
import axiosInstance, { getAPIURL } from "../axiosInstance";
import { Users } from "../../types/Types";

type UpdateUserDto = Partial<Users>;

export const useSaveUser = (
  options?: UseMutationOptions<
    Users,
    unknown,
    Users | UpdateUserDto | FormData,
    unknown
  >
) => {
  return useMutation({
    ...options,
    mutationFn: (data: Partial<Users> | FormData) => {
      const isFormData = data instanceof FormData;
      
      // Determine if it's an update or create operation
      const hasId = isFormData ? data.get('id') ?? null : (data as Partial<Users>).user?.id ?? null;
      
      // Set headers for FormData
      const config = isFormData 
        ? { headers: { 'Content-Type': 'multipart/form-data' } }
        : {};

      if (hasId) {
        return axiosInstance
          .put(getAPIURL(`/User/Update`), data, config)
          .then((res) => res.data);
      } else {
        return axiosInstance
          .post(getAPIURL("/User/Create"), data, config)
          .then((res) => res.data);
      }
    },
  });
};
